/* tslint:disable */
/* eslint-disable */
/**
 * Ptw100 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues, typeFirst } from '../runtime';
import type { CreateEnumerationValueDto } from './CreateEnumerationValueDto';
import {
    CreateEnumerationValueDtoFromJSON,
    CreateEnumerationValueDtoFromJSONTyped,
    CreateEnumerationValueDtoToJSON,
} from './CreateEnumerationValueDto';
import type { CreateNumericListDto } from './CreateNumericListDto';
import {
    CreateNumericListDtoFromJSON,
    CreateNumericListDtoFromJSONTyped,
    CreateNumericListDtoToJSON,
} from './CreateNumericListDto';
import type { CreateNumericValueDto } from './CreateNumericValueDto';
import {
    CreateNumericValueDtoFromJSON,
    CreateNumericValueDtoFromJSONTyped,
    CreateNumericValueDtoToJSON,
} from './CreateNumericValueDto';

/**
 * 
 * @export
 * @interface CreateElectronBeamQualityDto
 */
export interface CreateElectronBeamQualityDto {
    /**
     * 
     * @type {string}
     * @memberof CreateElectronBeamQualityDto
     */
    id?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CreateElectronBeamQualityDto
     */
    name?: string | null;
    /**
     * 
     * @type {CreateNumericListDto}
     * @memberof CreateElectronBeamQualityDto
     */
    availableDoseRates: CreateNumericListDto;
    /**
     * 
     * @type {CreateNumericValueDto}
     * @memberof CreateElectronBeamQualityDto
     */
    energy: CreateNumericValueDto;
    /**
     * 
     * @type {CreateEnumerationValueDto}
     * @memberof CreateElectronBeamQualityDto
     */
    radiationType: CreateEnumerationValueDto;
    /**
     * 
     * @type {CreateEnumerationValueDto}
     * @memberof CreateElectronBeamQualityDto
     */
    highDoseTechniqueType: CreateEnumerationValueDto;
    /**
     * 
     * @type {string}
     * @memberof CreateElectronBeamQualityDto
     */
    $type?: CreateElectronBeamQualityDtoTypeEnum;
}


/**
 * @export
 */
export const CreateElectronBeamQualityDtoTypeEnum = {
    PtwPtw100AppZeroApplicationSharedMedicalSystemComponentDtoTreatmentMachinesConfigurationCreateElectronBeamQualityDtoPtwPtw100AppZeroApplicationShared: 'Ptw.Ptw100.AppZero.Application.Shared.MedicalSystemComponent.Dto.TreatmentMachines.Configuration.CreateElectronBeamQualityDto, Ptw.Ptw100.AppZero.Application.Shared'
} as const;
export type CreateElectronBeamQualityDtoTypeEnum = typeof CreateElectronBeamQualityDtoTypeEnum[keyof typeof CreateElectronBeamQualityDtoTypeEnum];


/**
 * Check if a given object implements the CreateElectronBeamQualityDto interface.
 */
export function instanceOfCreateElectronBeamQualityDto(value?: unknown): value is CreateElectronBeamQualityDto {
    return !!value && typeof value === 'object' && "$type" in value && value.$type === Object.values(CreateElectronBeamQualityDtoTypeEnum)[0];
}

export function CreateElectronBeamQualityDtoFromJSON(json: any): CreateElectronBeamQualityDto {
    return CreateElectronBeamQualityDtoFromJSONTyped(json, false);
}

export function CreateElectronBeamQualityDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateElectronBeamQualityDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'availableDoseRates': CreateNumericListDtoFromJSON(json['availableDoseRates']),
        'energy': CreateNumericValueDtoFromJSON(json['energy']),
        'radiationType': CreateEnumerationValueDtoFromJSON(json['radiationType']),
        'highDoseTechniqueType': CreateEnumerationValueDtoFromJSON(json['highDoseTechniqueType']),
        '$type': !exists(json, '$type') ? undefined : json['$type'],
    };
}

export function CreateElectronBeamQualityDtoToJSON(value?: CreateElectronBeamQualityDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return typeFirst({
        
        'id': value.id,
        'name': value.name,
        'availableDoseRates': CreateNumericListDtoToJSON(value.availableDoseRates),
        'energy': CreateNumericValueDtoToJSON(value.energy),
        'radiationType': CreateEnumerationValueDtoToJSON(value.radiationType),
        'highDoseTechniqueType': CreateEnumerationValueDtoToJSON(value.highDoseTechniqueType),
        '$type': value.$type,
    });
}

